export default __webpack_public_path__ + "static/media/login.277393b0.svg";